export default __webpack_public_path__ + "static/media/user-cluster.43cfdd75.svg";